import { Actions } from '@/utils/dictionaries/actionsDictionary/actions'

type Action = (typeof Actions)[keyof typeof Actions]

interface MenuLink {
  href: string
  text: string
}

interface MenuOption {
  id: string
  title: string
  icon: string
  href?: string
  accordion?: string
  action: Action
  links: MenuLink[]
}

export const MENU_OPTIONS: MenuOption[] = [
  {
    id: '1',
    title: 'Consultar participantes',
    icon: '/img/participants.svg',
    href: '/members',
    links: [],
    action: Actions.LIST_USERS
  },
  {
    id: '6',
    title: 'Acelerador de pontos',
    icon: '/img/acceleration.svg',
    href: '/acceleration',
    links: [],
    action: Actions.LIST_ACCELERATIONS
  },
  {
    id: '8',
    title: 'Benefícios resgatáveis',
    icon: '/img/benefits.svg',
    accordion: '/benefits',
    action: Actions.LIST_BENEFITS_EVENTS,
    links: [
      {
        href: '/benefits/events',
        text: 'Eventos'
      }
    ]
  }
]
